import { Container } from '@shared/ui/Container';

import { Form } from './Form/Form';
import cls from './Feedback.module.scss';

export const Feedback = () => {
  return (
    <Container className={cls.wrap}>
      <div className={cls.inner}>
        <div className={cls.title}>Закажите мебель, идеально подходящую к вашему интерьеру</div>
        <Form />
        <div className={cls.decorLeft} />
        <div className={cls.decorRight} />
      </div>
    </Container>
  );
};
